import { Controller } from "@hotwired/stimulus"

// Keeps a bottom-fixed element above Mediavine's adhesion ad. The ad is
// injected after load into #fixed_container_bottom, sits at the maximum
// z-index, and changes height with each creative (or disappears when closed),
// so a fixed offset can't clear it. Publishes the ad's visible height as
// --ad-clearance on the element for its own positioning.
export default class extends Controller {
  connect() {
    this.update = this.update.bind(this)
    this.resizeObserver = new ResizeObserver(this.update)
    this.mutationObserver = new MutationObserver(() => this.observeAds())
    this.mutationObserver.observe(document.body, { childList: true })
    window.addEventListener("resize", this.update)
    this.observeAds()
  }

  disconnect() {
    this.resizeObserver.disconnect()
    this.mutationObserver.disconnect()
    this.containerObserver?.disconnect()
    window.removeEventListener("resize", this.update)
  }

  observeAds() {
    const container = document.getElementById("fixed_container_bottom")
    if (container && container !== this.container) {
      this.container = container
      this.containerObserver?.disconnect()
      this.containerObserver = new MutationObserver(() => this.observeAds())
      this.containerObserver.observe(container, { childList: true, subtree: true })
    }

    this.resizeObserver.disconnect()
    this.adWrappers().forEach((wrapper) => this.resizeObserver.observe(wrapper))
    this.update()
  }

  update() {
    const clearance = this.adWrappers().reduce((max, wrapper) => {
      const rect = wrapper.getBoundingClientRect()
      if (rect.height === 0 || getComputedStyle(wrapper).visibility === "hidden") return max

      return Math.max(max, window.innerHeight - rect.top)
    }, 0)

    this.element.style.setProperty("--ad-clearance", `${Math.round(clearance)}px`)
  }

  adWrappers() {
    return Array.from(document.querySelectorAll(".adhesion_wrapper"))
  }
}
